<template>
  <v-row class="filters__dates mt-0" no-gutters>
    <v-col>
      <v-menu :close-on-content-click="false" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :label="label"
            @click:clear="handleClearDate()"
            v-model="dateShow"
            v-bind="attrs"
            v-on="on"
            clearable
            readonly
            outlined
            dense
          />
        </template>
        <v-date-picker
          @change="handleDateSelected"
          v-model="dateSelect"
          color="primary"
          :locale="localeLanguage"
          no-title
          flat
        />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { catalogDateWithoutTime } from '@/util/catalog'
import store from '@/store'
import moment from 'moment'

import { dateOptions } from './FilterDatesOptions'

export default {
  name: 'FilterDatesRange',

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    singleDateProp: {
      type: String,
    },

    label: {
      required: false
    }
  },

  data() {
    return {
      date: catalogDateWithoutTime,
      dateSelect: null,
      dateShow: null,
      minDatePicker: '',
      params: {},
    }
  },

  computed: {
    ...mapGetters(['filters']),

    localeLanguage() {
      return localStorage.getItem('user_language') ?? 'pt-BR'
    },

    fieldLabel() {
      return this.label ? label : this.$t('filters.date.singleDate')
    }

  },

  methods: {
    ...mapMutations(['setFilters', 'setDatesValue', 'setCurrentPage']),

    handleDateSelected() {
      this.params[this.singleDateProp] = `${this.dateSelect}T00:00:01Z`
      this.minDatePicker = this.dateSelect

      this.setDatesValue({
        ...store.getters.datesValue,
        ...{
          [this.singleDateProp]: moment(this.dateSelect).format(
            'DD/MM/YYYY'
          ),
        },
      })

      this.dateShow = moment(this.dateSelect).format('DD/MM/YYYY')

      this.applyFilter()
    },

    handleClearDate() {
      this.params[this.singleDateProp] = ''

      this.setDatesValue({
        ...store.getters.datesValue,
        ...{
          [this.singleDateProp]: this.$t(
            `filters.date.${[dateOptions[0].title]}`
          ),
        },
      })

      this.applyFilter()
    },

    applyFilter() {
      this.isMenuOpened = false

      Promise.resolve(
        this.setFilters({ ...store.getters.filters, ...this.params })
      )
        .then(() => this.setCurrentPage(1))
        .then(() => this.fetchData())
    },
  },
}
</script>
